import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';

import Panel from 'react-bootstrap/lib/Panel';

import {
  faRocket,
  faRuler,
  faList,
  faChartLine,
  faDollarSign,
} from '@fortawesome/free-solid-svg-icons';

import Link from '../../../../../components/Link';
import PageLayout from '../../../../../components/PageLayout';

import ShadowerLink from '../../../../../components/ShadowerLink';

import Navbar from '../../../../../components/Handbook/Navbar';

import s from '../../HandbookPage.scss';

class ShadowingGuidelinesPage extends React.Component {
  render() {
    return (
      <PageLayout className={s.page}>
        <div className={s.container}>
          <div className={s.navbar}>
            <div className={s.title}>Shadowing Handbook</div>
            <Navbar
              navbarIcon={faRocket}
              navbarSection="Getting Started"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/welcome-to-shadower"
                  >
                    Welcome to Shadower
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/how-shadower-works"
                  >
                    How Shadower Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/working-with-businesses"
                  >
                    Working with Businesses
                  </Link>
                  <Link
                    className={cx(s.link, s.active)}
                    to="/handbook/getting-started/shadowing-guidelines"
                  >
                    Shadowing Guidelines
                  </Link>
                </div>
              }
              overrideDefault
            />

            <Navbar
              navbarIcon={faRuler}
              navbarSection="Planning a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/choosing-a-topic"
                  >
                    Choosing a Topic
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/interactivity-level"
                  >
                    Interactivity Level
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/session-type"
                  >
                    Session Type
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/providing-resources"
                  >
                    Providing Resources
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faList}
              navbarSection="Managing a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/expectations"
                  >
                    Expectations
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/session-flow"
                  >
                    Session Flow
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/maximizing-your-time"
                  >
                    Maximizing Your Time
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faChartLine}
              navbarSection="Promoting Your Profile"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/how-the-platform-works"
                  >
                    How the Platform Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/optimizing-your-profile"
                  >
                    Optimizing Your Profile
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/marketing-yourself"
                  >
                    Marketing Yourself
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/how-to-build-a-following"
                  >
                    How to Build a Following
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faDollarSign}
              navbarSection="Earning Revenue"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/earning-revenue/how-payment-works"
                  >
                    How Payment Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/earning-revenue/connecting-with-the-community"
                  >
                    Connecting with the Community
                  </Link>
                </div>
              }
            />

            <Link className={s.newProfileLink} to="/user/profiles/new">
              Create a shadowing profile
            </Link>
          </div>

          <div className={s.explanation}>
            <Panel>
              <Panel.Heading>
                <div>Getting Started</div>
              </Panel.Heading>
              <Panel.Body>
                <div className={s.handbookTitle}>A guide for experts</div>
                <div className={s.subsectionTitle}>Shadowing Guidelines</div>

                <div className={s.contentContainer}>
                  <p>
                    When creating a shadowing session, there are a few things
                    you should keep in mind:
                  </p>
                </div>

                <div className={s.contentContainer}>
                  <div>
                    <strong>Center the session on learning</strong>
                  </div>
                  <p>
                    At its core, Shadower is centered around education. We want
                    shadowers to be able to walk away with real-world knowledge
                    that they can apply to their own future projects and
                    personal endeavors.
                  </p>

                  <p>
                    We believe that hands-on training is the best form of
                    education, so we highly encourage experts to make their
                    sessions at least partially interactive, providing the
                    shadower with one or more responsibilities or projects.
                  </p>
                </div>

                <div className={s.contentContainer}>
                  <div>
                    <strong>Relationships are essential for growth</strong>
                  </div>
                  <p>
                    The average user has plenty of online options these days to
                    acquire information. The one thing that sets Shadower is
                    apart is the real-world, mentor-mentee relationship
                    available through the platform. These types of relationships
                    are difficult for many people to come by, especially those
                    without formal education or connections.
                  </p>

                  <p>
                    We encourage experts to use their shadowing session as an
                    opportunity to build an ongoing relationship with their
                    shadower as it provides a positive two-way outcome for both
                    parties. Shadowers will be more likely to return if they
                    feel that you genuinely care about helping them succeed and
                    the shadowers are more likely to recommend your sessions to
                    other people, spreading your reach within the community and
                    beyond.
                  </p>
                </div>

                <div className={s.contentContainer}>
                  <div>
                    <strong>
                      Following the community guidelines builds trust
                    </strong>
                  </div>

                  <p>
                    Without a sense of trust and safety on the platform, no one
                    will be interested in shadowing you, so we rely on every
                    expert to foster a safe learning environment by adhering to
                    our Community Guidelines, which can be found under Trust &
                    Safety in the <Link to="/help">Help Center</Link>.
                  </p>

                  <p>
                    For more about safe shadowing, refer to our{' '}
                    <Link to="/trust-and-safety">Trust and Safety</Link> page.
                  </p>
                </div>

                <ShadowerLink
                  className={s.nextLink}
                  to="/handbook/planning-a-session/choosing-a-topic"
                >
                  Next {'>'}
                </ShadowerLink>
              </Panel.Body>
            </Panel>
          </div>
        </div>
      </PageLayout>
    );
  }
}

export default withStyles(s)(ShadowingGuidelinesPage);
